import { getUrlPrefix } from '~/lang/locales'
import { reportApiError } from '~/utility/sentry/apiErrorReporter'
import { datepickerAvailabilityResultsSchema } from './schemas'
import {
  DatepickerFetchError,
  DatepickerValidationError,
} from './DatepickerError'
import { DatepickerAvailabilityResultsDay } from './types'

// Default timeout for datepicker requests (30 seconds)
const DATEPICKER_TIMEOUT = 30000

export class DatepickerAvailabilityServiceFetch {
  async get(
    langCode: string,
    slug: string,
    categories: Array<string> = [],
    pitchtypeId?: string,
  ): Promise<DatepickerAvailabilityResultsDay[]> {
    const params = categories.reduce((categoryParams, id) => {
      categoryParams.append('type', String(id))
      return categoryParams
    }, new URLSearchParams())
    if (pitchtypeId) {
      params.append('pitchtype_id', String(pitchtypeId))
    }
    const urlPrefix = getUrlPrefix(langCode)
    const url = `/_/fallback${urlPrefix}/_/datepicker/${slug}${params.size ? '?' + params.toString() : ''}`

    // Datepicker availability is non-critical — any failure returns empty
    // array so the page degrades gracefully without crashing.
    // Errors are still reported to Sentry for visibility.
    let response: unknown
    try {
      response = await $fetch(url, {
        timeout: DATEPICKER_TIMEOUT,
      })
    } catch (error: unknown) {
      reportApiError(
        new DatepickerFetchError(url, slug, categories, pitchtypeId, error),
        'datepicker-availability',
      )
      return []
    }

    try {
      return datepickerAvailabilityResultsSchema.parse(
        response,
      ) as DatepickerAvailabilityResultsDay[]
    } catch (error: unknown) {
      reportApiError(
        new DatepickerValidationError(
          url,
          slug,
          categories,
          pitchtypeId,
          response,
          error,
        ),
        'datepicker-availability',
      )
      return []
    }
  }
}
